<div class="container">
    <h5 class="rps-heading-five">Fund management</h5>
    <div *ngIf="overviewModel?.isInternalFund && overviewModel?.is529">
        <p class="rps-paragraph-one" data-rpa-tag-id="fundManagement">{{fundManagementText}}</p>
    </div>
    <div *ngIf="overviewModel?.isInternalFund && !overviewModel?.is529">
        <div *ngIf="overviewModel?.fundManagement.length>0; else mdash">
            <p class="rps-paragraph-one" *ngFor="let advisorName of overviewModel.fundManagement" data-rpa-tag-id="fundManagement">{{advisorName}}</p>
        </div>
        <ng-template #mdash>
            <h4 class="rps-heading-four" data-rpa-tag-id="fundManagement">&mdash;</h4>
        </ng-template>
    </div>
    <div *ngIf="overviewModel?.isExternalFund">
        <div *ngIf="overviewModel?.managerName && !overviewModel.isETF">
            <p class="rps-paragraph-one" data-rpa-tag-id="fundManagerName">Manager Name: {{overviewModel.managerName}}</p>
        </div>
        <div *ngIf="overviewModel?.managerName; else mdash">
            <p class="rps-paragraph-one" data-rpa-tag-id="fundManagerTenure">Manager Tenure: {{overviewModel.managerTenure}} years</p>
        </div>
        <ng-template #mdash>
            <h4 class="rps-heading-four">&mdash;</h4>
        </ng-template>
    </div>
</div>
